import React, { useEffect } from "react";
import { confirmPopup } from "primereact/confirmpopup";
import { Toast } from "primereact/toast";
import { setLatestDocument, resetMenu } from "../store/reducer";
import {
  getHotels,
  getDocByCatIDAndHotelID,
  saveDocumentsViewByUser,
  getNewDocuments,
} from "../api/api";
import * as util from "./constant";
import JSZip from "jszip";
import Tooltip from "react-bootstrap/Tooltip";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

var CryptoJS = require("crypto-js");
const key = CryptoJS.enc.Utf8.parse("b2b");
const options = {
  mode: CryptoJS.mode.ECB,
  padding: CryptoJS.pad.Pkcs7,
};

export const encrypt = (dataToEncrypt) => {
  /**
   * The function encrypts the given data using AES encryption and returns the encrypted data as a
   * string.
   * @param dataToEncrypt - The data that you want to encrypt. This can be a string, object, or any
   * other data type that can be converted to a string.
   * @returns The encrypted data as a string.
   */
  const encryptedData = CryptoJS.AES.encrypt(dataToEncrypt, key, options);
  return encryptedData.toString();
};

export const decrypt = (dataToDecrypt) => {
  /**
   * The function decrypts data using the AES encryption algorithm in JavaScript.
   * @param dataToDecrypt - The data that you want to decrypt. This should be a string that was
   * previously encrypted using the same encryption algorithm and key.
   * @returns The decrypted data as a string in UTF-8 format.
   */
  var decryptedData = CryptoJS.AES.decrypt(dataToDecrypt, key, options);
  console.log(
    "decryptedData :",
    CryptoJS.enc.Utf8.stringify(decryptedData),
    dataToDecrypt
  );

  return decryptedData.toString(CryptoJS.enc.Utf8);
};

export const nowDate = (isoFormat, option) => {
  /**
   * The `nowDate` function takes an ISO format date string and an optional option parameter, and returns
   * the date in the specified format.
   * @param isoFormat - The isoFormat parameter is a string representing the format of the input date. It
   * should be in the ISO 8601 format, which is a standardized format for representing dates and times.
   * Examples of ISO 8601 format include "2022-01-01" for a date or "2022
   * @param option - The "option" parameter is an optional parameter that allows you to specify
   * additional formatting options for the date string. It can be used to customize the output of the
   * date string according to your requirements.
   * @returns the date in the specified format and with the specified options.
   */
  return new Date(isoFormat).toLocaleDateString(isoFormat, option);
};

export function formatDate(inputDate) {
  const date = new Date(inputDate);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-GB", options);
  return formattedDate;
}

export function dateToString(datetoconvert) {
  let date = new Date(datetoconvert);

  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");

  // Format the date as YYYY-MM-DD
  return `${year}-${month}-${day}`;
}

export function dateDifference(date1, date2) {
  /**
   * The `dateDifference` function calculates the difference in days between two given dates.
   * @param date1 - The first date in the format "YYYY-MM-DD".
   * @param date2 - The `date2` parameter is the second date that you want to calculate the difference
   * with. It should be in the format "YYYY-MM-DD".
   * @returns the difference in days between two dates.
   */
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const start = new Date(date1);
  const end = new Date(date2);

  const months_and_days = [];

  while (start <= end) {
    const year = start.getFullYear();
    const month = String(start.getMonth() + 1);
    let name = months[month - 1];
    let numberOfDays = new Date(year, month, 0).getDate();
    months_and_days.push({
      year: year,
      month: name,
      numberOfDays: numberOfDays,
    });

    start.setMonth(start.getMonth() + 1);
  }
  return months_and_days;
}

export function getUrlLastParam() {
  /**
   * This JavaScript function extracts and returns the last parameter from a given URL pathname.
   * @param pathname - The `pathname` parameter in the `getUrlLastParam` function is expected to be a
   * string representing a URL pathname.
   * @returns The function `getUrlLastParam` returns the last parameter from the given `pathname`. If
   * there is a slash in the `pathname`, it will return the substring after the last slash. If there is
   * no slash or only one slash in the `pathname`, it will return `null`.
   */
  let pathname = window.location.pathname;
  const slashIndex = pathname.lastIndexOf("/");
  if (slashIndex !== -1 && slashIndex !== pathname.indexOf("/")) {
    return pathname.substring(slashIndex + 1);
  } else {
    return null;
  }
}

export function objectComparison(obj1, obj2) {
  /**
   * The function `objectComparison` compares two objects by converting them to strings using
   * `JSON.stringify` and checking for equality.
   * @param obj1 - Sure, please provide the first object (obj1) so that we can proceed with the
   * comparison.
   * @param obj2 - It seems like you forgot to provide the `obj2` parameter for the `objectComparison`
   * function. Could you please provide the `obj2` object so that I can help you compare it with `obj1`?
   * @returns The function `objectComparison` is returning a boolean value indicating whether the two
   * input objects `obj1` and `obj2` are equal in terms of their stringified representations.
   */
  const obj1String = JSON.stringify(obj1);
  const obj2String = JSON.stringify(obj2);
  return obj1String === obj2String;
}

export function removeObject(tab, object) {
  /**
   * The function `removeObject` removes a specific object from an array based on a comparison function.
   * @param tab - The `tab` parameter is an array that contains objects.
   * @param object - The `object` parameter in the `removeObject` function represents the object that you
   * want to remove from the `tab` array. This function finds the index of the `object` in the `tab`
   * array using a custom comparison function (`objectComparison`) and then removes it from the array if
   * @returns The `removeObject` function is returning the updated `tab` after removing the specified
   * `object` from it.
   */

  let list = tab;

  let itemIndex = list.findIndex((obj) => objectComparison(obj, object));
  if (itemIndex !== -1) {
    list.splice(itemIndex, 1);
  }

  return list;
}

export function deepObjectComparison(obj1, obj2) {
  /**
   * The function `deepObjectComparison` compares two objects deeply for equality.
   * @param obj1 - It seems like you were about to provide the first object for the deep object
   * comparison. Please go ahead and provide the first object (obj1) so we can continue with the
   * comparison.
   * @param obj2 - It seems like you were about to provide the second object for the deep object
   * comparison function. Please go ahead and provide the second object so we can compare it with the
   * first object.
   * @returns The `deepObjectComparison` function is returning `true` if the two objects `obj1` and
   * `obj2` are deeply equal (have the same properties and values), and `false` otherwise.
   */
  if (typeof obj1 !== "object" || typeof obj2 !== "object") {
    return obj1 === obj2;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (
      !obj2.hasOwnProperty(key) ||
      !deepObjectComparison(obj1[key], obj2[key])
    ) {
      return false;
    }
  }

  return true;
}

export const deepComparison = (obj1, obj2) => {
  
  if (typeof obj1 !== "object" || typeof obj2 !== "object") {
    return obj1 === obj2;
  }

  let isExist = JSON.stringify(obj1) === JSON.stringify(obj2);
  if (true) {
    return obj2;
  } else {
    return null;
  }
};

  

export function deepCompare(obj1, obj2) {

  /**
   * Deeply compares two objects for equality.
   * @param {Object} obj1 - The first object to compare.
   * @param {Object} obj2 - The second object to compare.
   * @returns {boolean} `true` if the two objects are deeply equal, and `false` otherwise.
   */
  
  if (
    typeof obj1 === "object" &&
    typeof obj2 === "object" &&
    obj1 !== null &&
    obj2 !== null
  ) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (!deepCompare(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  } else {
    return obj1 === obj2;
  }
}


export function isObjectInList(object, list) {

  /**
 * Checks if the given object is equal to any item in the given list.
 * The check is done using a deep comparison, i.e. the objects are equal if all their properties are equal.
 * @param {object} object - The object to check.
 * @param {array} list - The list of objects to check against.
 * @returns {boolean} true if the object is equal to any item in the list, false otherwise.
 */

  for (let item of list) {
    
    const newObj = (({ id, ...rest }) => rest)(item);
    const Obj1 = (({ id, ...rest }) => rest)(object);
   
    if (deepCompare(Obj1, newObj)) {
      return true;
    }
  }
  return false;
}

const isObject = (object) => {
  return object != null && typeof object === "object";
};


export const isDeepEqual = (object1, object2) => {

  /**
 * Checks if two objects are deeply equal.
 *
 * @param {Object} object1
 * @param {Object} object2
 * @returns {boolean}
 */

  const objKeys1 = Object.keys(object1);
  const objKeys2 = Object.keys(object2);

  if (objKeys1.length !== objKeys2.length) return false;

  for (var key of objKeys1) {
    const value1 = object1[key];
    const value2 = object2[key];

    const isObjects = isObject(value1) && isObject(value2);

    if (
      (isObjects && !isDeepEqual(value1, value2)) ||
      (!isObjects && value1 !== value2)
    ) {
      return false;
    }
  }
  return true;
};
export function getTotalSize(tab) {
  /**
   * The function `getTotalSize` calculates and returns the total size by summing up the numerical values
   * extracted from the "size" property of each item in the input array.
   * @param tab - An array of objects, where each object represents a tab and has a "size" property that
   * contains a string representing the size of the tab.
   * @returns The function `getTotalSize` returns the total size of all items in the `tab` array. If the
   * `tab` array is empty, it returns 0.
   */

  if (tab.length === 0) {
    return 0;
  }

  let sum = 0;

  tab.forEach((item, index) => {
    let value = parseFloat(item["size"].match(/\d+(\.\d+)?/)[0]);
    let extension = item["size"].replace(/[^a-zA-Z]/g, "");

    if (extension.toUpperCase() === "KB") {
      value /= 1024;
    } else if (extension.toUpperCase() === "GB") {
      value *= 1024;
    }
    sum += value;
  });
  return sum.toFixed(2);
}


export const downloadItem = (e, item) => {
  /**
 * The function `downloadItem` takes an event and an item object as parameters and triggers a file download of the item.
 * @param e - The event that triggered the function call.
 * @param item - The object that represents the item to be downloaded. The object should have a "name" property with the file name and a "filePath" property with the file path.
 * @returns The function does not return a value.
 */
  e.preventDefault();
  downloadFile(item.name, item.filePath);
};



const isDownload = (val) => {

  /**
 * The function `isDownload` dispatches an action to update the state of whether a download is in
 * progress.
 * @param val - The `val` parameter in the `isDownload` function is the value that will be passed to
 * the `isDownloading` action creator to indicate whether a download is in progress or not.
 */

  const { store } = require("../store/store");
  const { isDownloading } = require("../store/reducer");
  store.dispatch(isDownloading(val));
};

  
export const downloadFile = async (filename, url) => {

  /**
   * The function `downloadFile` downloads a file from a provided URL and saves it
   * to the user's machine with the provided filename.
   * @param filename - The filename to save the file as.
   * @param url - The URL of the file to download.
   * @returns The function `downloadFile` returns a boolean value indicating whether
   * the file was downloaded successfully.
   */
  
  isDownload(true);

  const isDownloaded = await fetch(url).then((response) => {
    response.blob().then((blob) => {
      // Creating new object of PDF file
      const fileURL = window.URL.createObjectURL(blob);

      let a = document.createElement("a");
      a.href = fileURL;
      a.download = `${filename}`;

      a.click();
      setTimeout(() => {
        isDownload(false);
      }, 2000);

      return true;
    });
  });
};

 
export const downloadFilesAsZip = async (filenames, urls) => {

   /**
   * The function `downloadFilesAsZip` downloads multiple files as a ZIP archive.
   * @param filenames - An array of strings, where each string is the filename to be used for the
   * corresponding URL in the `urls` array.
   * @param urls - An array of URLs, where each URL is downloaded and added to the ZIP archive.
   * @returns The function `downloadFilesAsZip` returns a boolean value indicating whether the ZIP
   * archive was downloaded successfully.
   */
  
  if (filenames.length !== urls.length) {
    throw new Error("The number of filenames and URLs must be the same.");
  }

  const zip = new JSZip();
  isDownload(true);
  // Fetch files and add them to the ZIP
  const fetchPromises = urls.map((url, index) =>
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => zip.file(filenames[index], blob))
  );

  try {
    await Promise.all(fetchPromises);

    const content = await zip.generateAsync({ type: "blob" });

    // Create a download link for the ZIP file
    const fileURL = URL.createObjectURL(content);
    const a = document.createElement("a");
    a.href = fileURL;
    a.download = "Cart.zip";
    a.click();

    // Clean up the URL object
    URL.revokeObjectURL(fileURL);
    setTimeout(() => {
      isDownload(false);
    }, 2000);

    return true;
  } catch (error) {
    console.error("Error downloading files:", error);
  }
  setTimeout(() => {
    isDownload(false);
  }, 2000);

  return true;
};

export function toSnakeCase(str) {
  return typeof str === "string"
    ? str.replace(/\s+/g, "_").replace(/&/g, "and").toLowerCase()
    : "";
}

export function getElapsedTime(targetDate) {
  /**
   * The function `getElapsedTime` calculates the difference in hours between the current date and a
   * target date.
   * @param targetDate - The `getElapsedTime` function calculates the elapsed time in hours between the
   * current date and time and a target date and time provided as the `targetDate` parameter. The
   * function returns the elapsed time in hours as an integer.
   * @returns The function `getElapsedTime` returns the difference in hours between the current date and
   * time (now) and the target date provided as an argument.
   */

  const now = new Date();
  const target = new Date(targetDate);

  const diffMs = target.getTime() - now.getTime();
  const diffHours = Math.floor(Math.abs(diffMs / (1000 * 60 * 60)));
  
  return diffHours;
}

export const rowIndex = (data, props) => {
  /**
   * The rowIndex function returns the index of a row in a data set incremented by 1.
   * @param data - The `data` parameter typically refers to the dataset or array of items that you are
   * working with. It could be an array of objects, each representing a row of data in a table or list.
   * @param props - Props are the properties that are passed to a React component. In this case, the
   * `props` parameter likely contains information related to the current row being rendered in a table
   * or list. The `rowIndex` property within `props` is used to determine the index of the current row,
   * starting from
   * @returns A JSX element is being returned, which displays the row index incremented by 1 inside a
   * `<div>` element.
   */
  return <div>{props.rowIndex + 1}</div>;
};

export function confirmDelete(e, callback, itemName) {
  /**
   * "confirmDeleteActivity" is a function that takes two parameters, "e" and "data", and it prevents
   * the default action of the event, and then it calls the "confirmPopup" function with the parameters
   * "target", "message", "icon", "acceptClassName", and "accept".
   * @param e - The event object
   * @param data - The data object that is passed to the confirmPopup function.
   */

  e.preventDefault();
  let name = itemName ? itemName : "Item";

  confirmPopup({
    target: e.currentTarget,
    message: "Do you want to delete this " + name + "?",
    icon: "pi pi-info-circle",
    acceptClassName: "p-button-danger",
    accept: callback,
  });
}

export function accept(moduleName, action, toast) {
  let desc = "😬 Failed to ";
  if (action === "save") {
    desc = "😎 " + moduleName + " has been saved successfully. \n";
  }
  if (action === "delete") {
    desc = "😭 " + moduleName + " has been deleted successfully. \n";
  }
  if (action === "copy") {
    desc = moduleName + " has been copied. \n";
  }
  if (action === "mail") {
    desc = "Mail has been sent successfully. \n";
  }

  toast.show({ severity: "success", summary: "", detail: desc, life: 5000 });
  return <Toast ref={(el) => (this.toastBR = el)} position="bottom-right" />;
}

export function reject(errors, action, toast) {
  /**
   * Shows a toast message when an error occurs. The message includes the action that was attempted,
   * and the error message.
   * @param {object} errors - The error object
   * @param {string} action - The action that was attempted (save, delete, get)
   * @param {Toast} toast - The toast component to show the error message
   * @returns {JSX.Element} An empty JSX element
   */

  let msg = "😬 Failed to ";
  if (action === "save") {
    msg = "save; \n";
  } else if (action === "delete") {
    msg = "delete; \n";
  } else if (action === "get") {
    msg = "get; \n";
  }

  msg += String(errors);

  toast.show({ severity: "warn", summary: "Error", detail: msg, life: 5000 });
  return <></>;
}

export async function getMenuItems(lang) {
  /**
   * @function getMenuItems
   * @description Retrieve the menu items.
   * @param {string} lang - The language code.
   * @returns {Array} An array of objects representing the menu items.
   */

  const hotels = await getHotels();

  let data = [];
  let hotelItems = {
    name: "Hotels",
    id: "hotels",
    type: "accordion-menu",
    icon: "hotels",
    firstChild: util.quickInfo,
    rank: 2,

    children: [],
  };
  let menuItems = [
    {
      name: "Destination",
      id: "destination",
      type: "simple-menu",
      icon: "destination",
      firstChild: util.mauritius,
      children: [{ ...util.mauritius }],
    },
  ];

  let tempHotel = [];
  if (Array.isArray(hotels)) {
    hotels.pop(); // to remove the last hotel which is Beachcomber Group
    hotels.forEach((hotel) => {
      let temp = {};
      temp.id = hotel.hotel_id;
      temp.name = hotel.hotel_name;
      tempHotel.push(temp);
      temp.children = util.submenuItems;
      data.push(temp);
    });
    hotelItems.children = data;
  }
  menuItems.push(hotelItems);
  menuItems.push({
    name: "Toolbox",
    id: "toolbox",
    type: "accordion-menu",
    icon: "toolbox",
    rank: 3,
    firstChild: util.hotelFactsheets,
    children: [
      {
        name: "Factsheets",
        id: "2205",
        children: [
          util.hotelFactsheets,
          util.mealPlanFactsheets,
          util.thematicalFactsheets,
          util.beachcomberExp,
        ],
      },
      {
        name: "Brochures",
        id: "2209",
        children: [
          util.hotelBrochure,
          util.B2B_brochure,
          util.brochureSpa,
          util.WeddingBrochures,
          util.GolfBrochure,
          util.divingBrochures,
        ],
      },
      {
        name: "Prime program",
        id: "2215",
        children: [util.primeProgram],
      },
      {
        name: "Menus",
        id: "2244",
        children: [util.spaMenu, util.restaurantsMenus, util.barMenus],
      },
      {
        name: "Room capacities & location",
        id: "room-capacities-&-location",
        children: [util.roomCapacitieslocation],
      },
      {
        name: "Eco-responsible document",
        id: "eco-responsible-document",
        children: [util.ecoResponsibleDocument],
      },
      {
        name: "Logos & Graphics Charts",
        id: "2230",
        children: [util.logo, util.logoPartners, util.graphicChart],
      },
      {
        name: "Floor plans",
        id: "2288",
        children: [util.floorPlans],
      },
    ],
  });
  menuItems.push({
    name: "News",
    id: "news",
    type: "simple-menu",
    icon: "news",
    rank: 4,
    firstChild: util.lUpdate,
    children: [util.lUpdate],
  });
  menuItems.push({
    name: "Pictures & Videos",
    id: "pictures_videos",
    type: "simple-menu",
    icon: "pictures",
    rank: 5,
    firstChild: util.pictures,
    children: [util.pictures],
  });
  menuItems.push({
    name: "Wedding",
    id: "wedding",
    type: "accordion-menu",
    icon: "wedding",
    rank: 6,
    firstChild: util.WeddingFactsheets,
    children: [
      {
        name: "Factsheets",
        id: "2205",
        children: [util.WeddingFactsheets],
      },
      {
        name: "Brochures",
        id: "2209",
        children: [util.WeddingBrochures, util.aLaCarteECatalogue],
      },
      {
        name: "Wedding calendar",
        id: "wedding-calendar",
        children: [util.weddingCalendar],
      },
      {
        name: "Pictures & Videos",
        id: "pictures",
        children: [util.pictures],
      },
    ],
  });
  menuItems.push({
    name: "MICE",
    id: "2227",
    type: "simple-menu",
    icon: "mice",
    rank: 7,
    firstChild: util.gIRates,
    children: [util.gIRates, util.gIFactsheets, util.pictures],
  });

  let room_status = {
    name: "Room status",
    id: "room_status",
    type: "simple-menu",
    icon: "room_status",
    rank: 8,
    firstChild: {
      id: hotels[0].hotel_id,
      name: hotels[0].hotel_name,
      url: util.roomStatusRoute,
      parent_id: "room_status",
    },
    children: [],
  };

  tempHotel.forEach((hotel) => {
    hotel.url = util.roomStatusRoute;
    room_status.children.push(hotel);
  });

  menuItems.push(room_status);
  menuItems.push({
    name: "Statistics",
    id: "2282",
    type: "simple-menu",
    icon: "logo_charte",
    rank: 9,
    firstChild: util.monthlyStatistics,
    children: [util.monthlyStatistics, util.forwardBookings],
  });
  menuItems.push({
    name: "Settings",
    id: "settings",
    type: "simple-menu",
    icon: "setting",
    rank: 10,
    firstChild: util.myAccount,
    children: [
      util.myAccount,
      util.changePassword,
      util.manageUsers,
      util.logout,
    ],
  });

  return menuItems;
}
const getExtension = (name) => {
  let parts = name.split("/");

  parts = parts[parts.length - 1];
  let ext = parts;
  if (parts.includes(".")) {
    parts = name.split(".");
    ext = parts[parts.length - 1];
  }
  return ext;
};
 
const mouldDocuments = (data, hotelID, catName, season) => {

   /**
   * @function
   * @description Moulds the documents coming from jsonapi to be used in the document table.
   * @param {array} data - The data coming from jsonapi.
   * @param {string} hotelID - The id of the hotel.
   * @param {string} catName - The category name.
   * @param {string} season - The season.
   * @returns {object} An object with the documents data.
   */

   
  let content = {
    id: Math.random(),
    type: catName,
  };

  let documents = [];

  if (data && data.length > 0) {
    data.forEach((doc, index) => {
      let tmp = {};
      tmp.id = doc.id;
      tmp.category = catName;
      tmp.name = "hotel name";
      tmp.date = season;
      tmp.title = doc.attributes.title;
      tmp.src = doc.attributes.thumbnail_pdf ?? "";
      tmp.data = [];
      let files = doc?.relationships?.list ?? [];

      files.forEach((file, index) => {
       
        
        let tmpFile = {};
        tmpFile.id = index;
        tmpFile.category = catName;
        tmpFile.title = tmp.title;
        tmpFile.name = file.field_media_document?.file_name ?? "";
        tmpFile.date = file.field_media_document?.file_updated ?? "";
        tmpFile.language = file?.field_language
          ? file.field_language.join(" - ")
          : [];
        tmpFile.type = getExtension(file.field_media_document.file_extension);
        tmpFile.resolution = file?.field_resolution ?? "";
        tmpFile.size = file?.field_media_document?.file_size ?? "";
        tmpFile.update = file?.field_media_document?.file_updated ?? "";
        tmpFile.download = index;
        tmpFile.src = file?.field_media_document?.file_thumbnail ?? "";
        tmpFile.filePath = file?.field_media_document?.default_url ?? "";
        tmp.data.push(tmpFile);
      });
     
      documents.push(tmp);
    });
  }
  content.data = documents;
  return content;
};

  
export async function getDocsByCategoryID(
  lang,
  name,
  id,
  categories,
  hotelID = null,
  season = null
) {

  /**
   * The function `getDocsByCategoryID` takes in the following parameters
   * - `lang`: The language of the documents to retrieve
   * - `name`: The name of the category to retrieve documents from
   * - `id`: The ID of the category to retrieve documents from
   * - `categories`: The categories list used to find the category by name
   * - `hotelID`: The hotel ID to filter documents by
   * - `season`: The season to filter documents by
   * The function first checks if the `name` parameter is not null. If it is not null,
   * it tries to find the category in the `categories` list using the `name` parameter.
   * If it finds a category, it sets the `catID` variable to the ID of the category.
   * If the `name` parameter is null, it sets the `catID` variable to the `id` parameter.
   * The function then calls the `getDocByCatIDAndHotelID` function to retrieve the documents
   * from the category and hotel ID, and then calls the `mouldDocuments` function to format
   * the retrieved documents. The function returns an array of the formatted documents.
   */

  
  let cat = null;
  let catID = 0;
  let doclist = [];


  if (name !== null) {
    if (name === "G & I rates") {
      name = "Groups &amp; Incentives rates";
    }
    if (name === "G & I factsheets") {
      name = "Groups &amp; Incentives factsheets";
    }
    if (name === "L'Update") {
      name = "L&#039;Update"; // this because Esokia doesn't encode specials characters
    }


    catID = id;
  }

  if (name === "Factsheets" || name === "Brochures") {
    catID = categories
      .filter((category) => category.parent_target_id === catID)
      .map((category) => ({ id: category.tid, name: category.title }));
  }

  // console.log('catID:',catID);
  // console.log('name:',name);
  // console.log('id:',id);

  // console.log('catID:',catID);

  // console.log('categories:',categories);
  
  
  if (Array.isArray(catID)) {
    for (const subCat of catID) {
      const data = await getDocByCatIDAndHotelID(
        lang,
        subCat.id,
        hotelID,
        season
      );


      if (data.length > 0) {
        let resp = mouldDocuments(
          data,
          hotelID,
          subCat.name.replace(/&amp;/g, "&").replace(/&#039;/g, "'"),
          season
        );
        doclist.push(resp);
      }
    }
  } else {
    const data = await getDocByCatIDAndHotelID(lang, catID, hotelID, season);
    
    if (data.length > 0) {
      let resp = mouldDocuments(
        data,
        hotelID,
        name.replace(/&amp;/g, "&").replace(/&#039;/g, "'"),
        season
      );
      doclist.push(resp);
    }
  }

  return doclist;
}

export const getHotelNameByID = (id, items) => {
  if (!items.length) {
    return null;
  }
  const hotel = items.find((item) => item.hotel_id === id);

  return hotel ? hotel.hotel_name : null;
};

export const numberToMonth = (number) => {
  // return new Date(0, number).toLocaleString("default", { month: "long" });
  return new Date(0, number).toLocaleString("en-US", { month: "long" });
};


export function getMonthNumber(monthName) {

  /**
 * Given a month name, returns the corresponding month number as a two-digit string
 * (e.g. "01" for January, "12" for December). If the month name is not recognized,
 * returns null.
 *
 * @param {string} monthName - The name of the month.
 * @returns {string|null} The month number, or null if the month name is not recognized.
 */

  const monthMap = {
    January: "01",
    February: "02",
    March: "03",
    April: "04",
    May: "05",
    June: "06",
    July: "07",
    August: "08",
    September: "09",
    October: "10",
    November: "11",
    December: "12",
  };

  return monthMap[monthName] || null;
}

const getColor = (str) => {
  let statusClass = " ";
  switch (str) {
    case "AB":
      statusClass = "bcb-bg-blue";
      break;
    case "A":
      statusClass = "bcb-bg-cyan";
      break;
    case "requested":
      statusClass = "bcb-bg-green";
      break;
    case "F":
      statusClass = "bcb-bg-green";
      break;
    case "R":
      statusClass = "bcb-bg-yellow";
      break;
    case "B":
      statusClass = "bcb-bg-gray";
      break;
    case "S":
      statusClass = "bcb-bg-red";
      break;
    default:
      statusClass = " bcb-bg-neutral";
  }

  return statusClass;
};

 
export const getStatusColor = (status) => {

   /**
   * Given a string representing a status, return an object with the status,
   * the corresponding color class, and the value of the status.
   *
   * The statuses and their corresponding colors are:
   * AB: bcb-bg-blue
   * A: bcb-bg-cyan
   * requested: bcb-bg-yellow
   * F: bcb-bg-yellow
   * R: bcb-bg-green
   * B: bcb-bg-gray
   * S: bcb-bg-red
   * Any other status: bcb-bg-neutral
   *
   * If the status is a comma-separated string, the second value is used as the
   * status, and the first value is used as the value.
   *
   * @param {String} status - A string representing a status.
   * @return {Object} - An object with the status, the color class, and the value.
   */
  
  let temp = [];
  let colorClass = "bcb-bg-neutral";
  let value = "";

  if (typeof status !== "string" || status === undefined) {
    return { status: "", color: "", value: "" };
  }
  let statusValue = status;
  temp = status.split(",");

  if (temp.length === 2) {
    colorClass = getColor(temp[1]);
    statusValue = temp[1];
    if (temp[0] !== temp[1]) {
      value = temp[1];
    }
  }

  return { status: statusValue, color: colorClass, value: value };
};

  
export const filterDocuments = (docs) => {

  /**
   * This function takes an array of documents and filters them into a nested
   * object structure based on the category they belong to. The structure is
   * as follows: { categoryID1: { category1: [docs], category2: [docs] }, categoryID2: { ... } }
   * This structure is then returned.
   *
   * @param {Array} docs - An array of documents to be filtered.
   * @return {Object} - The filtered documents in a nested object structure.
   */
  
  const { store } = require("../store/store");
  const storeState = store.getState();

  
  

  if (!docs || docs.length === 0) {
    return [];
}

 

  const categories = storeState.user.docCategories;
  
  let temp = {};
  categories.forEach((cat) => {
    temp[cat.tid] = {};
    temp[cat.tid][cat.title.replace('&amp;','&')] = []
  
  });


  
  
  docs.forEach((doc, index) => {
   
    for (let key in temp) {
      
      if (doc.category in temp[key]) {
        temp[key][doc.category].push(doc);
      }
    }
  });

  for (let val in temp) {
    let isEmpty = [];

    for (let i in temp[val]) {
      if (temp[val][i].length > 0) {
        isEmpty.push(false);
      } else {
        isEmpty.push(true);
      }
    }
    if (isEmpty.every((value) => value === true)) {
      delete temp[val];
    }
  }

  return temp;
};

  
const getDocsByID = (catID, filteredCat) => {

  /**
   * Filters the documents by category ID and returns an array of document objects.
   * @param {Number} catID - The category ID.
   * @param {Object} filteredCat - The filtered categories object.
   * @returns {Array<Object>} - An array of document objects, each containing the
   *   category name and the filtered documents.
   */
  
  return Object.entries(filteredCat).reduce((formattedDoc, [key, value]) => {
    let cat_name = getCategoryNameByCatID(catID);
    let decoded_name= cat_name.replace('&amp;','&')
    
    if (decoded_name in value && value[decoded_name].length > 0) {
      formattedDoc.push({
        category: decoded_name,
        content: value[decoded_name],
      });
    }

    return formattedDoc;
  }, []);
};

  
export const filterDocumentsByCategory = async (catID) => {

  /**
   * Fetches the documents by category ID, filters out the documents the user has
   * already viewed, and updates the store with the latest documents.
   * @param {Number} catID - The category ID.
   * @returns {Promise<Array<Object>>} - A promise that resolves to an array of
   *   document objects, each containing the category name and the filtered
   *   documents.
   */
  
  const { store } = require("../store/store");
  const storeState = store.getState();

  const { latestDocuments } = storeState.appState;
  const { userID } = storeState.user;


  const filteredCat = filterDocuments(latestDocuments);
  let formattedDoc = getDocsByID(catID, filteredCat);

  if (formattedDoc.length === 0 || formattedDoc[0].content.length === 0) {
    return formattedDoc;
  }

  const docs = formattedDoc[0]["content"];

  await Promise.all(
    docs.map(async (item) => {
      let doc = {
        id: item.id,
        has_view_id: item.has_view_id,
        uuid: item.uuid,
        has_view: item.has_view,
        user_id: userID,
      };
      return saveDocumentsViewByUser(doc);
    })
  );

  const newDoc = await getNewDocuments(userID);
  if (newDoc.data.length > 0) {
    store.dispatch(setLatestDocument(newDoc));

    const reFilteredCat = filterDocuments(newDoc.data);
    formattedDoc = getDocsByID(catID, reFilteredCat);
  }

  return formattedDoc;
};

 

export const getNotificationRoute = (docs) => {

  /**
 * The function `getNotificationRoute` filters documents and generates notification objects based on
 * the categories and their respective counts.
 * @param docs - The `getNotificationRoute` function takes a parameter `docs`, which is an object
 * containing document categories and their corresponding data. The function filters the documents
 * based on certain criteria and then generates notification routes based on the filtered data. The
 * function iterates over the filtered categories and creates notification objects with specific
 * properties
 * @returns The `getNotificationRoute` function returns an array of notification objects. Each
 * notification object contains the following properties: `id`, `name`, `url`, `parent_id`, and
 * `counter`.
 */

  const filteredCat = filterDocuments(docs);

  
  
  let notifications = [];

  if (!docs || docs.length === 0) {
    return [];
}

  for (let val in filteredCat) {
    if (Object.keys(filteredCat[val]).length > 0) {
      for (let key in filteredCat[val]) {
        let category = filteredCat[val][key];
        
        if (category.length > 0) {
          let unread =0;
          for(let index in category){
            if(category[index].has_view.toString() === '0' && category[index].is_new.toString() === '1'){
              unread+=1;
            }
          }
          let temp = {};
          temp.id = category[0]["category_id"];
          temp.name = `${key}`;
          temp.url = `/notifications/${convertToUrlSlug(key)}`;
          temp.parent_id = val;
          temp.counter = category.length;
          temp.unread = unread;
          notifications.push(temp);
        }
      }
    }
  }

  return notifications;
};

function convertToUrlSlug(str) {
  /**
   * Converts a string to a URL slug.
   *
   * This function takes a string and converts it to a URL slug by:
   * - Lowercasing the string.
   * - Replacing one or more whitespace characters with a single hyphen.
   * - Replacing any non-alphanumeric characters (other than hyphens) with an empty string.
   *
   * @param {string} str The string to be converted to a URL slug.
   * @returns {string} The URL slug.
   */

 
let convertedSrtring = str
.toLowerCase()
.replace(/\s+/g, "-")
.replace(/[^a-z0-9-]/g, "");

  return convertedSrtring;
}

export const getCategoryNameByCatID = (id) => {
  /**
   * Given a category ID, returns the corresponding category name.
   * If no category is found with the given ID, returns null.
   * @param {number} id The category ID.
   * @returns {string|null} The category name, or null if not found.
   */

  const { store } = require("../store/store");
  const storeState = store.getState();

  const categories = storeState.user.docCategories;
  let category = categories.find((item) => {
    return Number(item.tid) === id;
  });

  return category ? category.title : null;
};

export const renderTooltip = (val) => {
  /**
   * Returns a tooltip component with a translated string.
   *
   * @param {string} val - The value to be translated and displayed in the tooltip.
   * @return {JSX.Element} The rendered tooltip component.
   */

  function toSnakeCase(str) {
    return str.replace(/\s+/g, "_").replace(/&/g, "and").toLowerCase();
  }

  let name = toSnakeCase(val);

  return (
    <Tooltip id={"button-tooltip-" + name} className="custom-tooltip ">
      {name}
    </Tooltip>
  );
};

export const getNowSeason = (seasons) => {
  /**
   * Returns the season ID of the current year.
   * @param {Array} seasons - A list of season objects.
   * @returns {Number|null} The season ID of the current year, or null if not found.
   */

  const currentYear = new Date().getFullYear();
  const year = currentYear % 100;
  let season = seasons.filter((season) => {
    let first_val = season.title.replace("-", "/").split("/")[0];
    return Number(first_val) === year;
  });

  return season ? season[0].tid : null;
};

export const setHomeMenu = () => {
  /**
   * Resets the menu to its initial state.
   */
  const { store } = require("../store/store");

  store.dispatch(resetMenu({}));
};
